import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRefreshIconSolid = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "a",
	xmlns: "http://www.w3.org/2000/svg",
	width: 56.25,
	height: 56.25,
	viewBox: "0 0 56.25 56.25",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", { d: "M52.21,36.77c-3.4,10.53-13.12,17.6-24.19,17.6-8.26,0-15.84-4.04-20.52-10.56v8.68c0,2.07-1.68,3.75-3.75,3.75s-3.75-1.68-3.75-3.75v-16.88c0-2.07,1.68-3.75,3.75-3.75h15c2.07,0,3.75,1.68,3.75,3.75s-1.68,3.75-3.75,3.75h-5.2c3.3,4.62,8.66,7.5,14.58,7.5,7.8,0,14.66-4.98,17.05-12.4,.64-1.97,2.74-3.05,4.72-2.41,1.97,.53,3.06,2.74,2.31,4.71ZM56.25,3.75V20.62c0,2.07-1.68,3.75-3.75,3.75h-15c-2.07,0-3.75-1.68-3.75-3.75s1.68-3.75,3.75-3.75h5.2c-3.3-4.62-8.66-7.5-14.58-7.5-7.8,0-14.66,4.98-17.05,12.41-.64,1.97-2.74,3.06-4.72,2.41-1.97-.63-3.05-2.75-2.42-4.72C7.33,8.95,17.05,1.88,28.12,1.88c8.37,0,15.95,4.05,20.62,10.56V3.75c0-2.07,1.68-3.75,3.75-3.75s3.75,1.68,3.75,3.75Z" })]
});
const ForwardRef = forwardRef(SvgRefreshIconSolid);
export default ForwardRef;
